import './slowsgrandrapids/style';
import FormStructure from './slowsgrandrapids/form_structure';

export default FormStructure;